import { Component, OnInit } from '@angular/core';
import { DialogService, DialogComponent } from 'ng2-bootstrap-modal';
import { UserService } from 'src/app/services/user.service';
import { RequestsService } from 'src/app/services/requests.service';

export interface PromptModel{
  scope: any,
  currentRequest: any
}
@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.css']
})
export class RequestComponent extends DialogComponent<PromptModel, any> implements PromptModel{
  scope: any;
  currentRequest: any;
  shouldAdd: string="yes";
  constructor(
    public dialogoService: DialogService,
    private userService: UserService,
    private requestServices: RequestsService 
  ) { 
    super(dialogoService);
  }

  accept(){
    if(this.shouldAdd=="yes"){
      this.requestServices.setRequestStatus(this.currentRequest, 'accepted').then(
        (data)=>{
          console.log(data);
          this.userService.addFriend(this.scope.user.uid, this.currentRequest.sender).then(()=>{
            alert("solicitud aceptado");
            this.close();
          })
        },
        (error)=>{
          alert("ocurrio un error ");
          console.log(error);
        }
      )
    }else if(this.shouldAdd=="no"){
      this.requestServices.setRequestStatus(this.currentRequest, 'rejected').then(
        (data)=>{
          console.log(data);
          this.close();
        },
        (error)=>{
          console.log(error);
        }
      )
    }else if(this.shouldAdd=="later"){
      this.requestServices.setRequestStatus(this.currentRequest, 'decide_later').then(
        (data)=>{
          console.log(data);
          this.close();
        },
        (error)=>{
          console.log(error);
        }
      )
    }
  }


}
